<template>
  <div class="container">
    <div class="inner-header">
      <h2>
        Monetize Your Talent
      </h2>
      <h4>
        Earn an average payment of
        <span>
          BDT 17,700+
        </span>
      </h4>
      <div class="button_container space_y_50">
        <router-link to="/register/trainer">
          <a class="btn registration_next trainer-signup">
            Sign Up as trainer</a
          >
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// import UButton from '../core/UButton.vue'
export default {
  // components: { UButton },
}
</script>

<style scoped>
.registration_next {
  max-height: 50px;
  min-width: 350px;
  background-color: #0062ff;
  color: white !important;
}
.button_container {
  display: flex;
  justify-content: center;
}
.button_update {
  min-width: 350px;
  max-height: 50px;
}

.inner-header h2 {
  font: 700 5rem/3.75rem 'Open Sans';
  letter-spacing: -6.4px;
  text-align: center;
  color: black;
}
.inner-header h4 {
  margin-top: 20px;
  font: 300 3rem/2rem 'Open Sans';
  letter-spacing: -2.4px;
  text-align: center;
  color: black;
  word-wrap: break-word;
}
.inner-header h4 span {
  font: 700 3rem/2rem 'Open Sans';
  word-wrap: break-word;
}
@media only screen and (max-width: 700px) {
  .inner-header h2 {
    font: 700 3rem/3.75rem 'Open Sans';
    letter-spacing: -3.4px;
    text-align: center;
    color: black;
  }
  .inner-header h4 {
    margin-top: 20px;
    font: 300 2rem/1rem 'Open Sans';
    letter-spacing: -2.4px;
    text-align: center;
    color: black;
    word-wrap: break-word;
  }
  .inner-header h4 span {
    font: 700 2rem/4rem 'Open Sans';
    word-wrap: break-word;
  }
  .registration_next {
    margin-left: 0;
  }
}
</style>
